// Animación del footer

import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


function sectionAnimation() {

    const sections = document.querySelectorAll("article section, .scroll-fade-in");

    sections.forEach((section) => {

        gsap.set(section, {
            autoAlpha: 0,
            y: "20px",
        })
        gsap.to(section, {
            autoAlpha: 1,
            y: "0px",
            scrollTrigger: {
                trigger: section,
                start: "top bottom",
                toggleActions: "play pause resume reverse"
            }

        })
    })
}

sectionAnimation();